import { TDR } from 'tdr-common';
import { getParameterGuestMax } from './defaultParameterGuestMax';

export interface LeadGenPartySize {
	baseMax: number;
	displayMax: number;
	leadGenValue: number | null;
}

export function getLeadGenPartySize(restaurant: TDR.Restaurant | undefined): LeadGenPartySize {
	const baseMax = getParameterGuestMax(restaurant);
	const leadGenEnabled = !!restaurant?.settings?.parameterLeadGenEnabled;
	if (!leadGenEnabled) {
		return { baseMax, displayMax: baseMax, leadGenValue: null };
	}
	return { baseMax, displayMax: baseMax + 1, leadGenValue: baseMax + 1 };
}
